var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_124_8642)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_124_8642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.06927 15.7408C7.06927 15.3422 6.7927 15.1045 6.30473 15.1045C6.10547 15.1045 5.97052 15.1242 5.89993 15.143V16.4218C5.98351 16.4406 6.08625 16.4469 6.22787 16.4469C6.748 16.4469 7.06927 16.1841 7.06927 15.7408Z",
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0897 15.1182C9.87114 15.1182 9.72992 15.137 9.64639 15.1566V17.9888C9.72997 18.0084 9.86492 18.0084 9.98692 18.0084C10.8734 18.0147 11.4516 17.5267 11.4516 16.4927C11.4579 15.5935 10.931 15.1182 10.0897 15.1182Z",
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5802 1.17476C16.0179 0.614431 15.2565 0.299805 14.4627 0.299805H6.06284C4.65461 0.299805 3.50847 1.44674 3.50847 2.85417V12.2998H3.25899C2.69062 12.2998 2.22968 12.7603 2.22968 13.3291V19.5715C2.22968 20.1403 2.69057 20.6007 3.25899 20.6007H3.50847V21.7454C3.50847 23.1544 4.65461 24.2998 6.06284 24.2998H19.2153C20.6227 24.2998 21.769 23.1543 21.769 21.7454V7.59103C21.769 6.79355 21.4514 6.0289 20.8866 5.46599L16.5802 1.17476ZM4.92999 14.4556C5.23164 14.4047 5.65565 14.3662 6.25304 14.3662C6.85675 14.3662 7.28703 14.4815 7.57614 14.7129C7.85231 14.9311 8.03868 15.2911 8.03868 15.7148C8.03868 16.1384 7.89746 16.4986 7.6405 16.7425C7.30629 17.0571 6.81205 17.1984 6.23387 17.1984C6.1052 17.1984 5.98986 17.192 5.89966 17.1795V18.7274H4.92999V14.4556ZM19.2153 22.7354H6.06284C5.51757 22.7354 5.07355 22.2914 5.07355 21.7454V20.6007H17.3344C17.9029 20.6007 18.3637 20.1403 18.3637 19.5715V13.3291C18.3637 12.7603 17.9029 12.2998 17.3344 12.2998H5.07355V2.85417C5.07355 2.30969 5.51762 1.86567 6.06284 1.86567L15.117 1.85622V5.20295C15.117 6.18049 15.9101 6.9744 16.8884 6.9744L20.1669 6.96499L20.2038 21.7453C20.2038 22.2914 19.7606 22.7354 19.2153 22.7354ZM8.66394 18.7078V14.4556C9.02359 14.3984 9.49235 14.3662 9.98704 14.3662C10.8092 14.3662 11.3423 14.5137 11.76 14.8283C12.2096 15.1625 12.492 15.6952 12.492 16.4601C12.492 17.2885 12.1903 17.8605 11.7725 18.2134C11.3167 18.5924 10.6229 18.7721 9.77519 18.7721C9.26755 18.7721 8.9079 18.7399 8.66394 18.7078ZM15.674 16.1903V16.9865H14.1195V18.7274H13.1368V14.3984H15.7831V15.2009H14.1195V16.1903H15.674Z",
    fill: "#FF6B00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_124_8642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_124_8642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.299805)"
  })))));
}

export default SvgPdf;